import React from "react";
import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const NUMBER = "919099042472";

const EMPLOYER_MSG = "Hi Achievers Enterprise, I'd like to discuss a hiring requirement for my company.";
const CANDIDATE_MSG = "Hi Achievers Enterprise, I'm a job seeker and would like to know about relevant opportunities.";

export default function FloatingWhatsApp() {
  const location = useLocation();
  const isEmployer = location.pathname.startsWith("/for-employers") || location.pathname.startsWith("/employer");
  const msg = isEmployer ? EMPLOYER_MSG : CANDIDATE_MSG;
  const href = `https://wa.me/${NUMBER}?text=${encodeURIComponent(msg)}`;

  return (
    <a href={href} target="_blank" rel="noreferrer"
       aria-label="Chat on WhatsApp"
       data-testid="floating-whatsapp"
       className="fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#1EBE57] text-white w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110">
      <MessageCircle className="w-7 h-7" fill="white" />
      <span className="absolute right-full mr-3 whitespace-nowrap bg-[#0F2A4A] text-white text-xs px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
        Chat with us
      </span>
    </a>
  );
}
